export const JOB_EVENT_LIST = [
    {
        eventID: 1,
        jobID: 1,

        eventType: "installerAssigned",
        date: "01/01/2023",
        description: null
    },
    {
        eventID: 2,
        jobID: 1,

        eventType: "productionComplete",
        date: "02/01/2023",
        description: null
    },
    {
        eventID: 3,
        jobID: 1,

        eventType: "installationComplete",
        date: "05/01/2023",
        description: null
    },
    {
        eventID: 4,
        jobID: 1,

        eventType: "paymentRecieved",
        date: "09/01/2023",
        description: null
    },
    {
        eventID: 5,
        jobID: 1,

        eventType: "jobComplete",
        date: "13/01/2023",
        description: "Good job!"
    },
    {
        eventID: 6,
        jobID: 2,

        eventType: "installerAssigned",
        date: "18/01/2023",
        description: null
    },
    {
        eventID: 7,
        jobID: 2,

        eventType: "productionComplete",
        date: "20/01/2023",
        description: null
    },
    {
        eventID: 8,
        jobID: 2,

        eventType: "installationComplete",
        date: "23/05/2023",
        description: null
    },
    {
        eventID: 9,
        jobID: 2,

        eventType: "jobComplete",
        date: "28/01/2023",
        description: "Good job!"
    },
    {
        eventID: 10,
        jobID: 3,

        eventType: "installerAssigned",
        date: "01/02/2023",
        description: null
    },
    {
        eventID: 11,
        jobID: 3,

        eventType: "productionComplete",
        date: "02/02/2023",
        description: null
    },
    {
        eventID: 12,
        jobID: 3,

        eventType: "installationComplete",
        date: "03/02/2023",
        description: null
    },
    {
        eventID: 13,
        jobID: 4,

        eventType: "installerAssigned",
        date: "05/02/2023",
        description: null
    },
    {
        eventID: 14,
        jobID: 4,

        eventType: "productionComplete",
        date: "07/02/2023",
        description: null
    },
    {
        eventID: 15,
        jobID: 4,

        eventType: "installationComplete",
        date: "09/02/2023",
        description: null
    },
    {
        eventID: 16,
        jobID: 5,

        eventType: "installerAssigned",
        date: "11/02/2023",
        description: null
    },
    {
        eventID: 17,
        jobID: 5,

        eventType: "productionComplete",
        date: "12/02/2023",
        description: null
    },
    {
        eventID: 18,
        jobID: 6,

        eventType: "installerAssigned",
        date: "13/02/2023",
        description: null
    },
    {
        eventID: 19,
        jobID: 6,

        eventType: "productionComplete",
        date: "14/02/2023",
        description: null
    },
    {
        eventID: 20,
        jobID: 7,

        eventType: "installerAssigned",
        date: "15/02/2023",
        description: null
    },
    {
        eventID: 21,
        jobID: 7,

        eventType: "productionComplete",
        date: "21/02/2023",
        description: null
    },
    {
        eventID: 22,
        jobID: 8,

        eventType: "productionComplete",
        date: "24/02/2023",
        description: null
    },
    {
        eventID: 23,
        jobID: 9,

        eventType: "productionComplete",
        date: "02/03/2023",
        description: null
    },
    {
        eventID: 24,
        jobID: 10,

        eventType: "productionComplete",
        date: "04/03/2023",
        description: null
    },
    {
        eventID: 25,
        jobID: 11,

        eventType: "productionComplete",
        date: "16/03/2023",
        description: null
    },
    {
        eventID: 26,
        jobID: 13,

        eventType: "installerAssigned",
        date: "01/02/2023",
        description: null
    },
    {
        eventID: 27,
        jobID: 13,

        eventType: "productionComplete",
        date: "03/04/2023",
        description: null
    },
    {
        eventID: 28,
        jobID: 12,

        eventType: "productionComplete",
        date: "15/03/2023",
        description: null
    },
    {
        eventID: 29,
        jobID: 14,

        eventType: "installerAssigned",
        date: "01/02/2023",
        description: null
    },
    {
        eventID: 30,
        jobID: 14,

        eventType: "productionComplete",
        date: "02/02/2023",
        description: null
    },
    {
        eventID: 31,
        jobID: 14,

        eventType: "installationComplete",
        date: "05/04/2023",
        description: null
    },
    {
        eventID: 32,
        jobID: 15,

        eventType: "installerAssigned",
        date: "01/07/2023",
        description: null
    },
    {
        eventID: 33,
        jobID: 15,

        eventType: "productionComplete",
        date: "02/07/2023",
        description: null
    },
    {
        eventID: 34,
        jobID: 15,

        eventType: "installationComplete",
        date: "03/07/2023",
        description: null
    },
    {
        eventID: 36,
        jobID: 16,

        eventType: "installerAssigned",
        date: "02/02/2023",
        description: null
    },
    {
        eventID: 35,
        jobID: 16,

        eventType: "productionComplete",
        date: "01/04/2023",
        description: null
    },
]
